import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
import { FOOTER_HEIGHT, HEADER_HEIGHT } from '../../constants'
import { scrollbarStyles } from '../../theme/scrollbar'
import DashboardNavbar from './DashboardNavbar'
import DashboardSidebar from './DashboardSidebar'
import DashboardFooter from './DashboardFooter'
import { PracticeBanners } from './practices/PracticeBanners'
import { AnnouncementBanner } from '../common/banner/AnnouncementBanner'

const DashboardLayoutContainer = styled('div')({
	display: 'flex',
	flex: '1 1 auto',
	overflow: 'hidden'
})

// Native scrollbar styled to match the `react-perfect-scrollbar` look used by
// inner scroll containers (e.g. ChargeItems on /payments) so the page-level
// scrollbar — which appears on any page taller than the viewport, like
// /financing/capital — looks the same as the inner ones.
const DashboardLayoutContent = styled('div')({
	flex: '1 1 auto',
	height: '100%',
	overflow: 'auto',
	position: 'relative',
	WebkitOverflowScrolling: 'touch',
	...scrollbarStyles
})

const DashboardNavbarPlaceholder = styled('div')({
	height: '64px'
})

const DashboardLayout = () => {
	const [isSidebarMobileOpen, setIsSidebarMobileOpen] = useState(false)

	return (
		<div>
			<DashboardNavbar onSidebarMobileOpen={() => setIsSidebarMobileOpen(true)} />
			<DashboardNavbarPlaceholder />
			<Box
				display="flex"
				flexDirection="row"
				flexGrow={1}
				style={{ height: `calc(100vh - ${HEADER_HEIGHT} - ${FOOTER_HEIGHT})` }}
			>
				<DashboardSidebar
					onMobileClose={() => setIsSidebarMobileOpen(false)}
					openMobile={isSidebarMobileOpen}
				/>
				<DashboardLayoutContainer>
					<DashboardLayoutContent>
						<AnnouncementBanner />
						<PracticeBanners />
						<Outlet />
					</DashboardLayoutContent>
				</DashboardLayoutContainer>
			</Box>
			<DashboardFooter />
		</div>
	)
}

export default DashboardLayout
